import { ComputedTeam } from "shared/helpers/types/computed/ComputedTeam";
import { FC, useMemo } from 'react';
import {FlexBox} from "@brg/ui";
import {TFile} from "@brg/api";
import styled from "styled-components";
import { LayoutConst } from 'core';
import { useTranslation } from "react-i18next";

const HolderWrapper = styled(FlexBox)`
    width: 100%;
    height: 100%;
    justify-content: center;
    place-items: center;
    font-size: 280px;
    line-height: 224px;
    background-color: #CDCDCD;
    color: #fff;

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 34px;
    }
`;

export const TeamHolder: FC<{ team: ComputedTeam, files?: TFile[] }> = ({ team, files }) => {
    const { i18n: {language}} = useTranslation();

    const owner = useMemo(() => {
        return team && team?.owners?.[0]
    } , [team])

    const ownerFirstLetterName = useMemo(() => {
        if (owner && typeof owner?.name === 'string') {
            return owner?.name?.charAt(0)
        }
        return ''
    } , [owner])

    const holder = useMemo(() => {
        return `${ownerFirstLetterName}`.toUpperCase()
    }, [ownerFirstLetterName])

    return <HolderWrapper>{holder}</HolderWrapper>
}import { ComputedTeam } from "shared/helpers/types/computed/ComputedTeam";
import { FC, useMemo } from 'react';
import {FlexBox} from "@brg/ui";
import {TFile} from "@brg/api";
import styled from "styled-components";
import { LayoutConst } from 'core';
import { useTranslation } from "react-i18next";

const HolderWrapper = styled(FlexBox)`
    width: 100%;
    height: 100%;
    justify-content: center;
    place-items: center;
    font-size: 280px;
    line-height: 224px;
    background-color: #CDCDCD;
    color: #fff;

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 34px;
    }
`;

export const TeamHolder: FC<{ team: ComputedTeam, files?: TFile[] }> = ({ team, files }) => {
    const { i18n: {language}} = useTranslation();

    const owner = useMemo(() => {
        return team && team?.owners?.[0]
    } , [team])

    const ownerFirstLetterName = useMemo(() => {
        if (owner && typeof owner?.name === 'string') {
            return owner?.name?.charAt(0)
        }
        return ''
    } , [owner])

    const holder = useMemo(() => {
        return `${ownerFirstLetterName}`.toUpperCase()
    }, [ownerFirstLetterName])

    return <HolderWrapper>{holder}</HolderWrapper>
}